module.exports = __webpack_public_path__ + "static/media/15.17ba1ea8.jpg";